import template from './stPrefixes.html';
import controller from './stPrefixes.controller';

let stPrefixesComponent = {
  restrict: 'E',
  bindings: {
    data: '='
  },
  template,
  controller,
  controllerAs: 'vm'
};

export default stPrefixesComponent;



// WEBPACK FOOTER //
// ./client/app/common/stPrefixes/stPrefixes.component.js